// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ba7f21e6","952":"942486f2"}[chunkId] + ".chunk.js";
};